export const GDPR_REVIEW_COMPLETED_KEY = 'gdpr_review_completed';
